module.exports = __webpack_public_path__ + "img/dude.dfb04c17.jpg";